// Product URL utility service
// Simple utility to extract domain name from URLs for display purposes

export const extractDomain = (url) => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.toLowerCase();
  } catch {
    return 'unknown';
  }
};

export const formatUrl = (url) => {
  if (!url) return '';
  
  // Add https:// if no protocol is specified
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`;
  }
  
  return url;
};

export const getStoreName = (url) => {
  const domain = extractDomain(url);
  
  const storeNames = {
    'komplett.no': 'Komplett',
    'elkjop.no': 'Elkjøp',
    'power.no': 'Power',
    'clasohlson.no': 'Clas Ohlson',
    'ikea.no': 'IKEA',
    'zalando.no': 'Zalando',
    'hm.no': 'H&M',
    'amazon.com': 'Amazon',
    'amazon.co.uk': 'Amazon UK',
    'amazon.de': 'Amazon DE',
    'amazon.fr': 'Amazon FR',
    'apple.com': 'Apple',
    'samsung.com': 'Samsung',
    'sony.com': 'Sony',
    'lg.com': 'LG'
  };
  
  return storeNames[domain] || domain;
};